import React, { useState } from "react";
import { CTAButton } from "./UI";

const SERVICES = [
  {
    n: "01", title: "Brand",
    tag: "Identity & Design",
    desc: "We build brands that people remember. From strategy and identity to visual systems and graphic design — your brand is the foundation everything else is built on.",
    items: ["Brand Strategy", "Logo & Identity", "Visual Systems", "Graphic Design"],
  },
  {
    n: "02", title: "Digital",
    tag: "Web & E-commerce",
    desc: "Your website is your most powerful sales tool. We design and develop websites, landing pages and online stores that look like your brand and work for your business.",
    items: ["Business Websites", "Landing Pages", "E-commerce Stores", "Digital Experiences"],
  },
  {
    n: "03", title: "Content",
    tag: "Creative Production",
    desc: "Content is what gets you noticed. We produce social content, ad creatives, campaign shoots and brand films that make your business stand out in a crowded feed.",
    items: ["Social Media Content", "Ad Creatives", "Campaign Shoots", "Brand Films"],
  },
  {
    n: "04", title: "Growth",
    tag: "Performance & Ads",
    desc: "We run Meta Ads, Google Ads, SEO and social media management to put your business in front of people who are ready to buy — and turn attention into revenue.",
    items: ["Meta Ads", "Google Ads", "SEO", "Social Media Management"],
  },
  {
    n: "05", title: "Systems",
    tag: "Automation & AI",
    desc: "Smart businesses run on smart systems. We build marketing automations, lead pipelines and AI-powered workflows that save time and scale your growth.",
    items: ["Marketing Automation", "Lead Systems", "Business Workflows", "AI Integration"],
  },
];

export default function Ecosystem() {
  const [openIdx, setOpenIdx] = useState(null);

  return (
    <section id="services" className="section ecosystem-dark">
      <div className="container">

        <div className="eco-head-row">
          <div>
            <span className="eyebrow" style={{ color: "var(--gold)" }}>Our Services</span>
            <h2 className="eco-heading">Everything your business needs to win online.</h2>
          </div>
          <p className="eco-head-sub">
            From first impression to repeat customer — we cover every stage of your digital growth.
          </p>
        </div>

        <div className="eco-services">
          {SERVICES.map((s, i) => {
            const isOpen = openIdx === i;
            return (
              <div
                key={s.n}
                className={"eco-service-row" + (isOpen ? " eco-open" : "")}
                onClick={() => setOpenIdx(isOpen ? null : i)}
              >
                <div className="eco-service-main">
                  <span className="eco-service-num">{s.n}</span>
                  <div className="eco-service-center">
                    <h3 className="eco-service-title">{s.title}</h3>
                    <span className="eco-service-tag">{s.tag}</span>
                  </div>
                  <p className="eco-service-desc">{s.desc}</p>
                  <span className="eco-service-toggle">{isOpen ? "−" : "+"}</span>
                </div>
                {isOpen && (
                  <div className="eco-service-detail">
                    {s.items.map((item) => (
                      <span className="eco-detail-pill" key={item}>{item}</span>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div className="eco-cta">
          <CTAButton href="#contact">Start a project</CTAButton>
        </div>

      </div>
    </section>
  );
}
